module.exports = __webpack_public_path__ + "static/media/dappNodeAnimation.e73c6e35.gif";